import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import { FormControl, Stack, Grid, Typography, TextField, Tab, Tabs, Button, IconButton, Tooltip } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ClearIcon from '@mui/icons-material/Clear';
import { checkNumber, checkString } from '../utilities/FormValidation';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import customStyles from 'app/shared-components/SelectCustomStyle';
import { Box } from '@mui/system';
import CustomDatePicker from '../utilities/CustomDatePicker';
import moment from 'moment';
import { set } from 'lodash';

const initialValue = {
    assetId:null,
    assetTypeId: "",
    assetName: "",
    assetSrlNum: "",
    handOverDate: null,
    expiryDate: null,
    handoverConfirmation: "",
    assetStatus: "",
    returnStatus: "",
    totalCost: "",
    remarks: "",
    employeeId: "",
    warrantyDtls: "",
    location: "",
    department: "",
    condition: "",
    approvalStatus: null,
    // expairyDays: "",
    purchasePrice: "",
    currentValue: "",
    vendorName: "",
}

const assetStatusOptions = [
    { value: 1, label: "NEW" },
    { value: 2, label: "REQUESTED" },
    { value: 2, label: "GRANTED" },
]
// const approvalStatusOptions = [
//     { value: 1, label: "PENDING_APPROVAL" },
//     { value: 2, label: "APPROVED" },
//     { value: 3, label: "REJECTED" },
// ]
const departmentOptions = [
    { value: 1, label: "HR" },
    { value: 2, label: "Deployment" },
    { value: 3, label: "Testing" },
    { value: 4, label: "BDE" },
]
const returnStatusOptions = [
    { value: 1, label: "RETURNED" },
    { value: 2, label: "PENDING" },
]

const AssetForm = () => {

    const assetsUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.assets}`;
    const addnewassetUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.addnewasset}`;
    const updateassetUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.updateasset}`;
    const assetTypeUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.assetType}`;
    const employeeUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
    const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
    const fileDownloadUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.downloadAssetAttachment}`;

    const [tabValue, setTabValue] = useState(0);
    const params = useParams()
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [validError, setValidError] = useState([]);
    const [checkSubmit, setCheckSubmit] = useState(false);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [hideDelete, setHideDelete] = useState(true);
    const [editData, setEditData] = useState();
    const [saveDisable, setSaveDisable] = useState(true);
    const [assetTypeOptions, setAssetTypeOptions] = useState([]);
    const [assetTypeLink, setAssetTypeLink] = useState("");
    const [employeeLink, setEmployeeLink] = useState("");
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [vendorNameOptions, setVendorNameOptions] = useState([]);
    const [assetData, setAssetData] = useState(initialValue);
    const [fileName, setFileName] = useState([]);
    const [attachments, setAttchments] = useState([]);
    const [hasFileUpload,setHasFileUplod] = useState (false);

    /* ----------------------------handle change------------------------------------- */

    const handleChange = (event, key) => {
        if (key === "handOverDate") {
            setAssetData({ ...assetData, handOverDate: moment(event).format('YYYY-MM-DD') });
        } else if (key === "expiryDate") {
            setAssetData({ ...assetData, expiryDate: moment(event).format('YYYY-MM-DD') });
        } else if (key === "totalCost"  || key === "purchasePrice" || key === "currentValue") {
            setAssetData({ ...assetData, [event.target.name]: Number(event.target.value) });
        } else {
            setAssetData({ ...assetData, [event.target.name]: event.target.value.toUpperCase() });
        }
    }

    // const handleApprovalStatusChange = (data) => {
    //     setAssetData({ ...assetData, approvalStatus: data.label });
    // }
    const handleAssetStatusChange = (data) => {
        setAssetData({ ...assetData, assetStatus: data.label });
    }
    const handleDepartmentChange = (data) => {
        setAssetData({ ...assetData, department: data.label });
    };
    const handleReturnStatusChange = (data) => {
        setAssetData({ ...assetData, returnStatus: data.label });
    };
    const handleAssetTypeChange = (data) => {
        setAssetData({ ...assetData, assetTypeId: data.value });
    };
    const handleEmployeeChange = (data) => {
        setAssetData({ ...assetData, employeeId: data.value });
    };
    // const handleVendorNameChange = (data) => {
    //     setAssetData({ ...assetData, vendorName: data.value });
    // };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFileName([...fileName, file.name])
        setAttchments([...attachments, file])
        setHasFileUplod(true);

        // setAssetData(prevValue => ({
        //     ...prevValue,
        //     attachments: [...prevValue.attachments, file]
        // }));

    }




    const fileDownload = async (name) => {
        const download = await OAuthService.getDownload(fileDownloadUrl + `/${name}`);
        const blob = download?.data
        if (blob) {
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    }

    const removeFile = (index) => {
        const uploadFileName = fileName.filter((item, i) => i !== index)
        // const uploadFile = assetData.attachments.filter((item,i)=> i !== index)
        // console.log("uploadFile:", uploadFile)
        setFileName(uploadFileName);
    }

    /* ----------------------------------assets------------------------------------------- */
    const handleSubmit = async () => {
        setCheckSubmit(true);
        const assetType = `${assetTypeUrl}/${assetData.assetTypeId}`
        const employee = `${employeeUrl}/${assetData.employeeId}`;
        const assets = {...assetData}
        assets.assetId=params.id;
        delete assets?.id;
        delete assets?.deleted;
        delete assets?._links;
        delete assets?.expairyDays;
        const json = JSON.stringify(assets);
        const blob = new Blob([json], {
            type: 'application/json'
        });
        const formData = new FormData();
        attachments ? attachments?.map((file) => {
            formData.append('attachments', file);
        }) : formData.append('attachments', {});
        formData.append("body", blob);
        try {
            if (params.id) {
                await OAuthService.updateUploadFile(`${updateassetUrl}?assetType=${assetType}&employee=${employee}`, formData);
                setSuccessMsg("Data Updated Successfully");
                setSnackState(true);
                setTimeout(() => { navigate('/assets'); }, 800);
            } else {
                await OAuthService.uploadFile(`${addnewassetUrl}?assetType=${assetType}&employee=${employee}`, formData);
                setSuccessMsg("Data saved Successfully");
                setSnackState(true);
                setTimeout(() => { navigate('/assets'); }, 800);
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
    }

    

    const getAsset = async () => {
        try {
            if (params.id) {
                const result = await OAuthService.getEditData(assetsUrl, params.id);
                const asset = result?.data;
                const attachmentsUrl =  `${assetsUrl}/${params.id}/attachments`;
                const attachment = await OAuthService.getList(attachmentsUrl);
                const fileName = attachment?.data?._embedded?.dBFiles.map((file) => file.fileName);
                setFileName(fileName);
                const assetType = process.env.REACT_APP_HR_API_KEY_URL
                const assetType2 = asset._links.assetType.href.split("/api")[1]
                setAssetTypeLink(`${assetType}api${assetType2}`);
                const employLink = process.env.REACT_APP_HR_API_KEY_URL
                const employLink2 = asset._links.employee.href.split("/api")[1]
                setEmployeeLink(`${employLink}api${employLink2}`);
                setAssetData(asset);
                setEditData(asset);
            }
        } catch (e) {
            console.log(e);
        }
    }


    const handleDelete = async () => {
        try {
            if (params.id) {
                await OAuthService.deleteData(assetsUrl, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/assets') }, 800);
            }
        } catch (error) {
            console.log("error", error);
            setError(error.message);
        }
    }

    useEffect(() => {
        if (params.id) {
            getAsset();
            setHideDelete(false);
        }
    }, [params.id]);

    /* ----------------------------------Get-Asset-type------------------------------------------- */

    const getAssetTypes = async () => {
        try {
            const res = await OAuthService.getList(assetTypeUrl + '?sort=cityName,asc&size=1000');
            let assetType = res.data._embedded.assetTypes;
            assetType = assetType.map((type) => {
                return { value: type.id, label: type.displayName }
            });
            setAssetTypeOptions(assetType);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    const getAssetType = async () => {
        try {
            const res = await OAuthService.getList(assetTypeLink);
            const assetType = res.data.id;
            assetData.assetTypeId = assetType;
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    /* ----------------------------------Get-Employee------------------------------------------- */

    const getEmployees = async () => {
        try {
            const res = await OAuthService.getList(employeeUrl + '?sort=cityName,asc&size=1000');
            let employees = res.data._embedded.employees;
            employees = employees.map((employee) => {
                return { value: employee.employeeId, label: employee.displayName }
            });
            setEmployeeOptions(employees);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    const getEmployee = async () => {
        try {
            const res = await OAuthService.getList(employeeLink);
            const employee = res.data.employeeId;
            assetData.employeeId = employee;
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    useEffect(() => {
        const getDepartment = async () => {
            const employee = await OAuthService.getEditData(employeeUrl, assetData.employeeId);
            setAssetData({ ...assetData, department: employee.data.department });
        }
        getDepartment();
    }, [assetData.employeeId])
    /* ----------------------------------Get-Vendor------------------------------------------- */

    const getVendors = async () => {
        try {
            const res = await OAuthService.getList(factoryVendorUrl + '?sort=cityName,asc&size=1000');
            let vendors = res.data._embedded.factoryVendors;
            vendors = vendors.map((type) => {
                return { value: type.name, label: type.name }
            });
            setVendorNameOptions(vendors);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    useEffect(() => {
        if (params.id) {
            getAssetType();
            getEmployee();
        }
        getAssetTypes();
        getEmployees();
        getVendors();
    }, [assetTypeLink, employeeLink]);

    useEffect(() => {
        const errorValue = Object.values(validError).filter((item) => item !== undefined);
        if (
            assetData.assetTypeId && assetData.assetName && assetData.assetSrlNum && assetData.handOverDate &&
            assetData.expiryDate && assetData.handoverConfirmation && assetData.assetStatus && assetData.returnStatus &&
            assetData.totalCost && assetData.returnStatus && assetData.purchasePrice && assetData.currentValue
            && errorValue.length === 0 && fileName?.length > 0
        ) {
            if (editData) {
                if (JSON.stringify(assetData) !== JSON.stringify(editData) || ( fileName?.length && hasFileUpload)) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            } else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [assetData, validError, editData, fileName, hasFileUpload]);


    const handleCancel = () => {
        navigate("/assets")
    }

    return (
        <div className='w-full overflow-scroll'>
            <FormPageHeader
                componentName="Asset"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                successMsg={successMsg}
                snackState={snackState}
                currentPage={params.id ? "Update Asset" : "Add Asset"}
                parentBreadcrumbData={[{ pageName: 'Assets List', pageLink: '/assets' }]}
                error={error}
                handleCancel={handleCancel}
                hideDelete={hideDelete}
                saveDisable={saveDisable}
            >

                <Tabs
          value={tabValue}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: 'w-full h-64 border-b-1' }}
        >
          <Tab 
            className="h-64" 
            label="Basic Info" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
        </Tabs>
            </FormPageHeader>

            <div className="p-16 sm:p-24 ">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Asset SRL Number</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="assetSrlNum"
                                        value={assetData.assetSrlNum}
                                        error={(checkSubmit && !assetData.assetSrlNum) || validError.assetSrlNum ? true : false}
                                        helperText={(checkSubmit && !assetData.assetSrlNum) ? "" : validError.assetSrlNum}
                                        onChange={(e) => { handleChange(e); setValidError({ ...validError, assetSrlNum: checkNumber(e.target.value) }) }}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Asset Name</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="assetName"
                                        value={assetData.assetName}
                                        error={(checkSubmit && !assetData.assetName) || validError.assetName ? true : false}
                                        helperText={(checkSubmit && !assetData.assetName) ? "" : validError.assetName}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Select Asset Type</label>
                                    <Select
                                        className="mb-16"
                                        name="assetTypeId"
                                        value={(assetData.assetTypeId && assetTypeOptions) && assetTypeOptions.filter(obj => assetData.assetTypeId === obj.value)}
                                        onChange={handleAssetTypeChange}
                                        options={assetTypeOptions}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !assetTypeId) ? "" : validError.assetTypeId}</Typography> */}
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Handover Date</label>
                                    <CustomDatePicker 
                                        format={'dd-MM-yyyy'}
                                        name={'handOverDate'}
                                        value={assetData.handOverDate}
                                        handleChange={(e) => handleChange(e, "handOverDate")}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !handOverDate) ? "" : validError.handOverDate}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Expiry Date</label>
                                    <CustomDatePicker 
                                        format={'dd-MM-yyyy'}
                                        name={'expiryDate'}
                                        value={assetData.expiryDate}
                                        handleChange={(e) => handleChange(e, "expiryDate")}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !expiryDate) ? "" : validError.expiryDate}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Handover Confirmation</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="handoverConfirmation"
                                        value={assetData.handoverConfirmation}
                                        error={(checkSubmit && !assetData.handoverConfirmation) || validError.handoverConfirmation ? true : false}
                                        helperText={(checkSubmit && !assetData.handoverConfirmation) ? "" : validError.handoverConfirmation}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>*Select Asset Status</label>
                                    <Select
                                        className="mb-16"
                                        name="assetStatus"
                                        value={(assetData.assetStatus && assetStatusOptions) && assetStatusOptions.filter(obj => assetData.assetStatus === obj.label)}
                                        onChange={handleAssetStatusChange}
                                        options={assetStatusOptions}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !assetStatus) ? "" : validError.assetStatus}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>*Select Return Status</label>
                                    <Select
                                        className="mb-16"
                                        name="assetStatus"
                                        value={(assetData.returnStatus && returnStatusOptions) && returnStatusOptions.filter(obj => assetData.returnStatus === obj.label)}
                                        onChange={handleReturnStatusChange}
                                        options={returnStatusOptions}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !returnStatus) ? "" : validError.returnStatus}</Typography> */}
                                </Stack>
                            </Grid>
                        </Grid>
                        <Stack>
                            <label>Remarks</label>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="remarks"
                                value={assetData.remarks}
                                // error={(checkSubmit && !assetData.remarks) || validError.remarks ? true : false}
                                // helperText={(checkSubmit && !assetData.remarks) ? "" : validError.remarks}
                                onChange={(e) => handleChange(e)}
                                variant="outlined"
                            />
                        </Stack>

                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>Expiry Days</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="expairyDays"
                                        value={assetData.expairyDays}
                                        // error={(checkSubmit && !assetData.expairyDays) || validError.expairyDays ? true : false}
                                        // helperText={(checkSubmit && !assetData.expairyDays) ? "" : validError.expairyDays}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>Warranty Details</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="warrantyDtls"
                                        value={assetData.warrantyDtls}
                                        // error={(checkSubmit && !assetData.warrantyDtls) || validError.warrantyDtls ? true : false}
                                        // helperText={(checkSubmit && !assetData.warrantyDtls) ? "" : validError.warrantyDtls}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>Condition</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="condition"
                                        value={assetData.condition}
                                        // error={(checkSubmit && !assetData.condition) || validError.condition ? true : false}
                                        // helperText={(checkSubmit && !assetData.condition) ? "" : validError.condition}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>

                                <Stack>
                                    <label>*Select Employee</label>
                                    <Select
                                        className="mb-16"
                                        name="employeeId"
                                        value={(assetData.employeeId && employeeOptions) && employeeOptions.filter(obj => assetData.employeeId === obj.value)}
                                        onChange={handleEmployeeChange}
                                        options={employeeOptions}
                                        styles={customStyles()}
                                    />
                                    {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !employeeId) ? "" : validError.employeeId}</Typography> */}
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>Department</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="department"
                                        value={assetData.department}
                                        error={(checkSubmit && !assetData.department) || validError.department ? true : false}
                                        helperText={(checkSubmit && !assetData.department) ? "" : validError.department}
                                        onChange={(e) => handleChange(e)}
                                        disabled={true}
                                        variant="outlined"
                                    />
                                </Stack>
                                {/* <Stack>
                                    <label>Select Department</label>
                                    <Select
                                        className="mb-16"
                                        name="department"
                                        value={(assetData.department && departmentOptions) && departmentOptions.filter(obj => assetData.department === obj.label)}
                                        onChange={handleDepartmentChange}
                                        options={departmentOptions}
                                        styles={customStyles()}
                                    />
                                    <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checkSubmit && !department) ? "" : validError.department}</Typography>
                                </Stack> */}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Total Cost</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="totalCost"
                                        value={assetData.totalCost}
                                        error={(checkSubmit && !assetData.totalCost) || validError.totalCost ? true : false}
                                        helperText={(checkSubmit && !assetData.totalCost) ? "" : validError.totalCost}
                                        onChange={(e) => handleChange(e, "totalCost")}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Purchase Price</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="purchasePrice"
                                        value={assetData.purchasePrice}
                                        error={(checkSubmit && !assetData.purchasePrice) || validError.purchasePrice ? true : false}
                                        helperText={(checkSubmit && !assetData.purchasePrice) ? "" : validError.purchasePrice}
                                        onChange={(e) => handleChange(e, "purchasePrice")}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={4}>
                                <Stack>
                                    <label>*Current Value</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="currentValue"
                                        value={assetData.currentValue}
                                        error={(checkSubmit && !assetData.currentValue) || validError.currentValue ? true : false}
                                        helperText={(checkSubmit && !assetData.currentValue) ? "" : validError.currentValue}
                                        onChange={(e) => handleChange(e, "currentValue")}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>*Vendor Name</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="vendorName"
                                        value={assetData.vendorName}
                                        error={(checkSubmit && !assetData.vendorName) || validError.vendorName ? true : false}
                                        helperText={(checkSubmit && !assetData.vendorName) ? "" : validError.vendorName}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />

                                </Stack>
                                {/* <Stack>
                                    <label>Select Vendor Name</label>
                                    <Select
                                        className="mb-16"
                                        name="vendorName"
                                        value={(assetData.vendorName && vendorNameOptions) && vendorNameOptions.filter(obj => assetData.vendorName === obj.value)}
                                        onChange={handleVendorNameChange}
                                        options={vendorNameOptions}
                                        styles={customStyles()}
                                    />
                                    <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checkSubmit && !vendorName) ? "" : validError.vendorName}</Typography>
                                </Stack> */}

                                {/* <Stack>
                                    <label>*Select Approval Status</label>
                                    <Select
                                        className="mb-16"
                                        name="approvalStatus"
                                        value={(assetData.approvalStatus && approvalStatusOptions) && approvalStatusOptions.filter(obj => assetData.approvalStatus === obj.label)}
                                        onChange={handleApprovalStatusChange}
                                        options={approvalStatusOptions}
                                        styles={customStyles()}
                                    />
                                    <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checkSubmit && !approvalStatus) ? "" : validError.approvalStatus}</Typography>
                                </Stack> */}
                            </Grid>
                            <Grid item xs={6}>
                                <Stack>
                                    <label>Location</label>
                                    <TextField
                                        className="mb-16"
                                        type="text"
                                        name="location"
                                        value={assetData.location}
                                        // error={(checkSubmit && !assetData.location) || validError.location ? true : false}
                                        // helperText={(checkSubmit && !assetData.location) ? "" : validError.location}
                                        onChange={(e) => handleChange(e)}
                                        variant="outlined"
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Stack className='w-full mb-16'>
                            <label>*File Uploader</label>
                            <Box className='flex justify-center items-center'
                                sx={{
                                    height: 180,
                                    border: '2px dotted grey',
                                }}
                            >
                                <CloudUploadOutlinedIcon fontSize={'large'} /><Typography className='ml-12' >Upload File</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    color="warning"
                                    className='ml-12'
                                >
                                    <input hidden multiple type="file" onChange={(e) => handleFileChange(e)} />
                                    <Typography color="black">Browse</Typography>
                                </Button>
                            </Box>
                        </Stack>

                        <Stack className='w-full mb-16'>
                            {fileName.map((name, index) => {
                                return (

                                    <Box
                                        className='flex justify-between'
                                        key={index}
                                    >
                                        <Grid className='flex'>
                                            <div>
                                                <InsertDriveFileIcon fontSize={'large'} color="warning" className=' mt-20' />
                                            </div>
                                            <div>
                                                <Typography fontSize={'large'} className='ml-12 mt-20' >{name}</Typography>

                                            </div>
                                        </Grid>
                                        <Grid>
                                            <Tooltip title={"Download file"}>
                                                <IconButton className='mt-20 cursor-pointer' onClick={() => fileDownload(name)}><FileDownloadIcon className='w-32 h-32' /></IconButton>
                                            </Tooltip>
                                            <Tooltip title={"Remove file"}>
                                                <IconButton title='Remove file' className='mt-20 cursor-pointer' onClick={() =>{ 
                                                    removeFile(index);
                                                    !fileName?.length && setHasFileUplod(false)
                                                    }}><ClearIcon className='w-32 h-32' /></IconButton>
                                            </Tooltip>
                                        </Grid>
                                    </Box>
                                )
                            })}
                        </Stack>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default AssetForm